const styles = `:host {
  display: table-row-group;
}

::slotted(chameleon-data-table-row:not([disabled]):not([selected]):hover) {
  background-color: var(--goto-interactive-color-secondary-hover);
}

::slotted(chameleon-data-table-row:not([disabled]):not([selected]):active) {
  background-color: var(--goto-interactive-color-secondary-pressed);
}

::slotted(chameleon-data-table-row:not([disabled]):focus-visible) {
  border-color: var(--goto-focus-border-color-default);
  box-shadow: var(--goto-focus-color-highlight-default);
  background-color: var(--goto-interactive-color-disabled);
}`; export default styles;